var map = {
	"./bandera.png": 2175,
	"./bandera1.png": 134,
	"./buzo.png": 2710,
	"./buzo1.png": 941,
	"./camperas.png": 4786,
	"./camperas1.png": 4913,
	"./chomba.png": 8510,
	"./chomba1.png": 5,
	"./default.png": 9813,
	"./joggings.png": 6136,
	"./joggings1.png": 7424,
	"./otros.png": 3837,
	"./otros1.png": 6512,
	"./remeras.png": 8203,
	"./remeras1.png": 2410
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4978;